import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { OrderDetail, OrderDetailItem, ShoppingItemQuantity } from '../models/order-detail.model';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styles: [
  ]
})
export class OrderDetailComponent implements OnInit {

  searchString: string;
  orderDetail: OrderDetail;
  @Input() orderId: string;
  didUpdate: boolean = false;

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.ajax.MakeCall<OrderDetail>('/Order/AdminDetail', { orderId: this.orderId }).then((data) => {
      this.orderDetail = data;
    }, () => { });
  }

  selectUOM(i: OrderDetailItem, u: ShoppingItemQuantity): void {
    i.selectedUOM = u;
    i.showUpdate = true;
  }

  dismiss(): void {
    if (this.didUpdate) {
      this.modal.close();
    } else {
      this.modal.dismiss();
    }
  }

  downloadPDF(): void {
    window.open('/OrderPDF/' + this.orderDetail.orderId);
  }

  downloadEDI(): void {
    window.open('/File/Get/' + this.orderDetail.ediFileId);
  }

  submitUpdate(fQuantity: NgForm, fPrice: NgForm, i: OrderDetailItem, idx: number): void {
    i.submitAttempt = true;
    if (fQuantity.invalid || fPrice.invalid) {
      return;
    }

    // submit the changes
    this.ajax.MakeCall<OrderDetailItem>('/Order/SaveItem', i).then((data) => {
      this.orderDetail.items[idx] = data;
      this.didUpdate = true;
    }, () => { });
  }
}
